import { ChevronDownIcon } from "@heroicons/react/20/solid";
import React, { useState } from "react";
import { connect } from 'react-redux';

const ImportedEmployeeRow = ({ reference, rowNumber, errors, saved, isLast, hideSaved }) => {
    const [expand, setExpand] = useState(false)
    return (
        <>
            <div
                key={`${reference} - ${rowNumber}`}
                style={{ display: "grid", gridGap: "1.5rem", grid: "1.5rem", gridTemplateColumns: "repeat(5, minmax(0, 1fr))", padding: '1rem', borderBottom: (isLast && (expand ? errors.length === 0 : true)) ? undefined : 'solid rgb(244,244,244) 4px' }}>
                <div style={{ gridColumn: "span 1 / span 5", textAlign: 'center', paddingLeft: '1rem' }}>
                    <h5>{reference}</h5>
                </div>
                <div style={{ gridColumn: "span 1 / span 5", textAlign: 'center', paddingLeft: '1rem' }}>
                    <h5>{rowNumber}</h5>
                </div>
                <div style={{ gridColumn: "span 1 / span 5", textAlign: 'center', paddingLeft: '1rem' }}>
                    <h5>{errors?.length || 'None'}</h5>
                </div>
                <div style={{ gridColumn: "span 1 / span 5", textAlign: 'center', paddingLeft: '1rem' }}>
                    <h5>{saved ? 'Yes' : 'No'}</h5>
                </div>
                <div style={{ gridColumn: "span 1 / span 5", textAlign: 'center', paddingLeft: '1rem' }}>
                    {errors?.length > 0 ? <>
                        <button
                            className="btn btn-xs btn-default pull-right"
                            style={{ marginRight: '1.5rem' }}
                            onClick={() => { setExpand(!expand) }}
                        >
                            <ChevronDownIcon
                                style={{
                                    height: "1.5em",
                                    float: "left",
                                    transform: expand ? "rotate(180deg)" : "rotate(0deg)",
                                    transition: "transform 0.2s ease-in-out",
                                }} />
                        </button>
                    </> : null}
                </div>
            </div>
            {expand ? errors?.map((error, index) => {
                const lastError = isLast && (index + 1) === errors.length
                return (<>
                    <div
                        key={`${reference} - ${rowNumber} - ${index}`}
                        style={{ display: "grid", gridGap: "1.5rem", grid: "1.5rem", gridTemplateColumns: "repeat(5, minmax(0, 1fr))", padding: '1rem', borderBottom: lastError ? undefined : 'solid rgb(244,244,244) 4px' }}
                    >
                        <div style={{ gridColumn: "span 1 / span 5", paddingLeft: '1rem' }}>
                        </div>
                        <div style={{ gridColumn: "span 4 / span 5", paddingLeft: '1rem' }}>
                            {error}
                        </div>
                    </div>
                </>)
            }) : null}
        </>

    )
}

const mapStateToProps = (state) => {

    return {
    }
}

const mapDispatchToProps = dispatch => ({
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ImportedEmployeeRow)